module.exports = __webpack_public_path__ + "media/effects-21.3fca9e31.webm";